import axios from "../plugins/parseAxios";
export class BookingChannelAPI {
  static getBookingChannels(projectId) {
    return axios.post("functions/getBookingChannels", {
      projectId
    });
  }
  static createBookingChannel(formData) {
    return axios.post("functions/createBookingChannel", formData);
  }
  static updateBookingChannel(formData) {
    return axios.post("functions/updateBookingChannel", formData);
  }
  static removeBookingChannel(id) {
    return axios.post("functions/removeBookingChannel", { id });
  }
}
